import { useEffect, useRef, useState } from 'react';

export const useElementResize = () => {
  const ref = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    let observerRefValue: Element | null = null;
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setSize((prev) => ({
          ...prev,
          width: entry.contentRect.width,
          height: entry.contentRect.height,
        }));
      }
    });

    if (ref?.current) {
      observer.observe(ref.current);
      observerRefValue = ref.current;
    }

    return () => {
      if (observerRefValue) {
        observer.unobserve(observerRefValue);
      }
      observer.disconnect();
    };
  }, []);

  return { ref, size };
};
